var map = {
	"./de.png": 1025,
	"./en.png": 1026,
	"./es.png": 1027,
	"./fr.png": 1028,
	"./ja.png": 1029,
	"./mk.png": 1030,
	"./pt.png": 1031,
	"./tr.png": 1032,
	"./zh.png": 1033
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1024;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags ^\.\/.*\.png$
// module id = 1024
// module chunks = 0